import { MilestoneDto } from 'tdc-web-backend/milestones/schemas';
import { EnumCurrency } from 'tdc-web-backend/enums/enums';
import useGetMany from '../../../../../utils/hooks/crud-hooks/useGetMany';
import useAuth from '../../../../../utils/hooks/useAuth';
import RevenueChart from '../../../../EndToEnd/ProjectDetail/RevenueChart/RevenueChart';
import DashboardCard from '../../../../../components/dashboard-card/EndToEndCard.tsx/DashboardCard';

const ProjectPaymentGraphCard = () => {
  const {
    authData: { userData: user },
  } = useAuth();

  const { data: milestones } = useGetMany<MilestoneDto>({
    enabled: !!user,
    resource: `milestones?company=${user?.membership?.company}`,
  });
  return (
    <DashboardCard
      headline="Payments"
      mainCardClassName="react-joyride-step-7"
      sx={{ width: '100%', height: '450px' }}
      renderComponent={<RevenueChart milestones={milestones?.data.results as MilestoneDto[]} />}
      renderComponentSx={{ height: '100%', width: '100%' }}
    />
  );
};

export default ProjectPaymentGraphCard;
